// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2FI9S","validationTips":"StatementDescriptor_validationTips__1LPIN"};